const util = require('./util')

const passwordInput = document.querySelector('.password-toggle')
const passwordButton = document.querySelector('.password-toggle-button')
if (passwordButton && passwordButton) {
  passwordButton.addEventListener('click', function () {
    passwordInput.type = passwordInput.type === 'text' ? 'password' : 'text'
    util.toggleClass(this, 'password-toggle-button--visible')
  })
}
